<div class="animated fadeInRight">
  <!-- MENU DE TITULOS -->
  <app-lfsa-card-v2 [innTemplateButton]="innTemplateButton" [innTemplate]="enviarTemplateEdit"
    [modulo]="DAT_TITULOS.modulo" [tituloCard]="DAT_TITULOS.titulo" [titulo]="DAT_TITULOS.titulo">
  </app-lfsa-card-v2>
  <!-- MENU DE TITULOS -->

  <!-- OPCIONES LATERAL IZQUIERDO -->
  <ng-template #innTemplateButton>
    <div class="col-md-6 mb-2">
      <div class="pagetitle">
        <div class="btn-group-justified btn-group" style="float: right;">
          <button (click)="nuevo()" class="btn btn-outline-success">
            <i aria-hidden="true" class="fa fa-plus"></i>
            {{DAT_BTNS.nuevo}}
          </button>
        </div>
      </div>
    </div>
  </ng-template>
  <!-- OPCIONES LATERAL IZQUIERDO -->

  <!-- GRILLA -->
  <ng-template #enviarTemplateEdit>
    <app-lfsa-loading-v2 *ngIf="loading"></app-lfsa-loading-v2>
    <ag-grid-angular #agGrid (gridReady)="onGridReady($event)" [class]="DAT_AG_GRID.class" [columnDefs]="columnDefs"
      [floatingFilter]="true" [frameworkComponents]="frameworkComponents" [id]="DAT_AG_GRID.id"
      [ngStyle]="DAT_AG_GRID.style" [paginationPageSize]="DAT_AG_GRID.paginacion" [pagination]="true"
      [rowData]="rowData">
      [rowSelection]="'single'"
    </ag-grid-angular>
  </ng-template>
  <!-- GRILLA -->
</div>

<!-- MODAL -->
<app-lfsa-modal [classModal]="'modal-lg'" [idButton]="'abrirModal'" [idClose]="'cerrarModal'" [innTemplate]="abrirModal"
  [titulo]="tituloModal"></app-lfsa-modal>
<ng-template #abrirModal>
  <div class="container-fluid">
    <form [formGroup]="agregarForm" mat-dialog-content>
      <div class="row">
        <div class="row">
          <div *ngIf="!isCreate" class="form-group col-3">
            <app-lfsa-input [control]="this.agregarForm.get('id')" [id]="'id'" [label]="'ID'" formControlName="id"
              type="number"></app-lfsa-input>
            <small *ngIf="this.agregarForm.get('id')?.hasError('pattern')" class="letrasDanger">*Solo
              números y punto, hasta 4 decimales. Ej: 12.34</small>
          </div>

          <div class="col-9">
            <label>Tipo</label>
            <select (change)="onChangeTipo()" class="form-control" formControlName="tipo" name="tipo">
              <option value="">-- Seleccione --</option>
              <option value="0">Acidez</option>
              <option value="1">HumedadImpureza</option>
            </select>
            <!-- <div *ngIf="formBascula.controls['estado'].invalid && (formBascula.controls['estado'].dirty || formBascula.controls['estado'].touched)"
                            class="text-danger">
                            <small>
                                <div *ngIf="formBascula.controls['estado'].errors">
                                    Este campo es requerido.
                                </div>
                            </small>
                        </div> -->
          </div>
          <div class="col-6">
            <div class="mb-2">
              <label for="">Proveedor</label>
              <input (change)="onChangeProveedor($event);" (keydown)="noWhitespace($event)"
                (keyup)="onChangeProveedor($event);this.agregarForm.controls['proveedor'].value.length > 0 ? onChangeValues() : ''"
                autocomplete="off" class="form-control" formControlName="proveedor" name="proveedor" type="text">
              <div *ngIf="proveeControl?.hasError('required') && proveeControl.touched" class="text-danger">
                <small>*Este campo es requerido</small>
              </div>
              <div *ngIf="proveedorInvalido" class="text-danger">
                <small>*Este proveedor es inválido</small>
              </div>
            </div>
          </div>
          <div class="col-6">
            <div class="mb-2">
              <label for="">Desc. Proveedor</label>
              <input autocomplete="off" class="form-control" formControlName="despro" name="despro" readonly
                type="text">
            </div>
          </div>

          <div class="form-group col-6">
            <app-lfsa-input (change)="onChangeDates()" [control]="this.agregarForm.get('fechaIni')" [id]="'fechaIni'"
              [label]="'Fecha inicio'" formControlName="fechaIni" type="date"></app-lfsa-input>
            <small *ngIf="this.agregarForm.get('fechaIni')?.hasError('pattern')" class="letrasDanger">*Solo
              números y punto, hasta 4 decimales. Ej: 12.34</small>
            <small *ngIf="dateNotLessCurrent" class="text-danger">
              *La Fecha Final no puede ser menor a la Fecha Inicial
            </small>
          </div>

          <div class="form-group col-6">
            <app-lfsa-input (change)="onChangeDates()" [control]="this.agregarForm.get('fechaFin')" [id]="'fechaFin'"
              [label]="'Fecha Fin'" formControlName="fechaFin" type="date"></app-lfsa-input>
            <small *ngIf="this.agregarForm.get('fechaFin')?.hasError('pattern')" class="letrasDanger">*Solo
              números y punto, hasta 4 decimales. Ej: 12.34</small>
          </div>

          <div class="row">
            <div class="form-group col-3">
              <app-lfsa-input [control]="this.agregarForm.get('acidezBase')" [id]="'acidezBase'" [label]="'Valor base'"
                formControlName="acidezBase" type="text"></app-lfsa-input>
              <small *ngIf="this.agregarForm.get('acidezBase')?.hasError('pattern')" class="letrasDanger">*Solo
                números y punto, hasta 2 decimales. Ej: 12.34</small>
            </div>
            <div class="form-group col-3">
              <app-lfsa-input [control]="this.agregarForm.get('valorMin')" [id]="'valorMin'" [label]="'Valor mínimo'"
                formControlName="valorMin" type="text"></app-lfsa-input>
              <small *ngIf="this.agregarForm.get('valorMin')?.hasError('pattern')" class="letrasDanger">*Solo
                números y punto, hasta 2 decimales. Ej: 12.34</small>
            </div>
            <div class="form-group col-3">
              <app-lfsa-input [control]="this.agregarForm.get('valorMax')" [id]="'valorMax'" [label]="'Valor máximo'"
                formControlName="valorMax" type="text"></app-lfsa-input>
              <small *ngIf="this.agregarForm.get('valorMax')?.hasError('pattern')" class="letrasDanger">*Solo
                números y punto, hasta 2 decimales. Ej: 12.34</small>
            </div>
            <div class="form-group col-3">
              <app-lfsa-input [control]="this.agregarForm.get('incremento')" [id]="'incremento'" [label]="'Incremento'"
                formControlName="incremento" type="text"></app-lfsa-input>
              <small *ngIf="this.agregarForm.get('incremento')?.hasError('pattern')" class="letrasDanger">*Solo
                números y punto, hasta 2 decimales. Ej: 12.34</small>
            </div>
          </div>

        </div>
        <div *ngIf="dateValidate" class="mt-3 mb-2 text-danger">
          *No se puede crear un registro con el mismo proveedor, código de origen y material, cuando
          la fecha actual se encuentre entre la fecha inicio y fecha fin, como en el siguiente registro:
        </div>

        <!-- (ejecutarEvento)="getCuentasContables()" -->
        <app-lfsa-botones-formulario (devolverAccion)="acciones( $event )" [formularioValido]="agregarForm.invalid"
          [loading]="loading" [textBoton]="'Guardar'" class="row mt-3">
        </app-lfsa-botones-formulario>
      </div>
    </form>
  </div>

</ng-template>
<!-- END MODAL -->